export default __webpack_public_path__ + "static/media/pio-logo.1edf8289.png";